<template>
  <div id="app">
    <!--header start-->
    <div id="header">
      <div class="head">
        <div id="logo" onclick="">
          <img @click="pageClick('/index')" src="../static/imgs/logo1.jpg" width="70" height="70" alt="" style="margin-right: 20px;">
          <div style="color: black;font-size: 38px;letter-spacing:2px"> 青岛西海岸新区第五人民医院</div>      
        </div>
        <div class="header_contact">
          <div class="header_contact_icon">
            <img class="header_contact_icon_image" src="../static/imgs/tel.png" width="50" height="50" alt="">
          </div>
          <div class="header_contact_text">
            <div class="header_contact_text_title">24小时服务热线</div>
            <div class="header_contact_text_tel">{{ base.top_phone }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--header end-->
    <router-view v-if="isRouterAlive" />
    <!--footer start-->
    <div id="footer">
      <div class="footer">
        <div class="footer_left">
          <p>急救电话：120</p>
          <p>邮编：{{ base.post_code }}</p>
          <p>地址：{{ base.contact_address }}</p>
          <p>服务热线：{{ base.bottom_phone }}</p>
          <div class="footer_copyright">
            <span>
              <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2023040362号</a>
            </span>
            <span>
              技术支持：<a href="javascript:void(0);">中能创智(青岛)技术服务有限公司</a>
            </span>
          </div>
        </div>
        <div class="footer_right">
          <img src="../static/imgs/weichat.png" width="130" height="130" alt="">
          <div class="footer_right_text">微信公众号</div>
        </div>
      </div>

    </div>
    <!--start end-->
  </div>
</template>

<script>
import IndexApi from '@/api/index.js';
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true,
      base: {
        top_phone: '',//联系电话-顶部
        contact_phone: '',//联系电话-联系我们
        bottom_phone: '',//联系电话-底部
        post_code: '',//邮政编码
        contact_address: '',//地址-联系我们
        contact_website: '',//网址-联系我们
        contact_email: '',//邮箱-联系我们
        contact_pic: '',//图片-联系我们
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    /*页面跳转*/
    pageClick(row) {
      this.$router.push(row);
    },
    getData() {
      let self = this;
      IndexApi.baseinfo(true)
        .then(res => {
          self.loading = false;
          var list = res.data;
          for (let i = 0; i < list.length; i++) {
            if (list[i].dictParentKey == 'top_phone') {
              self.base.top_phone = list[i].dictName;
            }
            if (list[i].dictParentKey == 'contact_phone') {
              self.base.contact_phone = list[i].dictName;
            }
            if (list[i].dictParentKey == 'bottom_phone') {
              self.base.bottom_phone = list[i].dictName;
            }
            if (list[i].dictParentKey == 'post_code') {
              self.base.post_code = list[i].dictName;
            }
            if (list[i].dictParentKey == 'contact_address') {
              self.base.contact_address = list[i].dictName;
            }
            if (list[i].dictParentKey == 'contact_website') {
              self.base.contact_website = list[i].dictName;
            }
            if (list[i].dictParentKey == 'contact_email') {
              self.base.contact_email = list[i].dictName;
            }
            if (list[i].dictParentKey == 'contact_pic') {
              self.base.contact_pic = list[i].dictName;
            }
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style lang="scss">
.ivu-page-total {
  font-size: 18px;
}

.ivu-page-custom-text {
  font-size: 18px;
}

.ivu-page-item {
  font-size: 18px;
  padding: 2px;
}

.ivu-page-item a {
  font-size: 18px;
}

.ivu-page-custom-text a {
  font-size: 18px;
}

.ivu-page-next a,
.ivu-page-prev a {
  font-size: 18px !important;
}

.ivu-page {
  display: flex;
  justify-content: center;
}

.ivu-page li {
  margin: 0 10px;
}

.ivu-page-item-active {
  background: #007E4F !important;
  border: none !important;
}

.ivu-page-item-active a {
  color: #fff !important;
}

#header {
  background: #fff;
  height: 140px;
  position: relative;

  .head {
    width: 1180px;
    margin: 0 auto;
    padding: 35px 0;
    display: flex;
    justify-content: space-between;

    #logo {
      // width: 610px;
      height: 70px;
      cursor: pointer;
      display: flex;
      align-items: center;
    }

    .header_contact {
      padding: 11px 0px 0 0;
      display: flex;

      .header_contact_icon {
        padding: 0 18px 0 0;
      }

      .header_contact_text {
        .header_contact_text_title {
          font-size: 18px;
          color: #333;
          height: 25px;
          line-height: 25px;
        }

        .header_contact_text_tel {
          font-size: 20px;
          color: #333;
          height: 28px;
          line-height: 28px;
          font-weight: bold;
        }
      }
    }
  }
}

#header::before {
  position: absolute;
  content: '';
  left: 0;
  bottom: 0;
  right: 0;
  height: 2px;
  background: #EFEFEF;
}

#nav {
  height: 82px;

  ul.nav {
    width: 1180px;
    height: 82px;
    line-height: 82px;
    display: flex;
    margin: 0 auto;

    li {
      flex: 1;
      font-size: 24px;
      list-style: none;
      text-align: center;
      color: #333;
      cursor: pointer;
    }

    li.active {
      color: #007E4F;
    }
  }
}

#footer {
  margin: 50px 0 0 0;
  background: #007E4F;
  color: #fff;

  .footer {
    width: 1180px;
    height: 246px;
    margin: 0 auto;
    display: flex;
    ;
    justify-content: space-between;

    .footer_left {
      padding-top: 30px;
      font-weight: lighter;
      font-size: 18px;

      p {
        height: 38px;
        line-height: 38px;
        font-weight: lighter;
      }
    }

    .footer_right {
      padding-top: 41px;

      .footer_right_text {
        font-size: 18px;
        height: 30px;
        line-height: 30px;
        text-align: center;
      }
    }
  }

  .footer_copyright {
    text-align: center;
    font-size: 18px;
    font-weight: lighter;
    padding: 0 0 20px 0;
  }

  //.footer_copyright span{padding:0 10px;}
  .footer_copyright a {
    font-size: 18px;
    color: #fff;
    font-weight: lighter;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue